var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-switcher" },
    [
      _c(
        "div",
        {
          staticClass: "view-item title-item",
          on: { click: _vm.selectMainTable },
        },
        [
          _c("i", { staticClass: "material-icons" }, [_vm._v("table_chart")]),
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("tables.mainTable")) +
              " - " +
              _vm._s(_vm.table.name) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _vm._l(_vm.table.views, function (view) {
        return _c("div", { key: view._id, staticClass: "view-item" }, [
          _c(
            "div",
            {
              staticClass: "view-content",
              on: {
                click: function ($event) {
                  return _vm.selectView(view)
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("keyboard_tab"),
              ]),
              _vm._v("\n            " + _vm._s(view.name) + "\n        "),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "view-actions",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.$_.noop.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "i",
                {
                  staticClass: "material-icons edit-icon",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.editView(view)
                    },
                  },
                },
                [_vm._v("edit")]
              ),
              _vm._v(" "),
              _c(
                "a-dropdown",
                { attrs: { trigger: ["click"] } },
                [
                  _c(
                    "i",
                    {
                      staticClass: "material-icons more-icon",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [_vm._v("more_vert")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-menu",
                    {
                      staticClass: "view-actions-menu",
                      attrs: { slot: "overlay" },
                      slot: "overlay",
                    },
                    [
                      _c(
                        "a-menu-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.renameView(view)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("edit"),
                          ]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("tables.renameView")) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.duplicateView(view)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("content_copy"),
                          ]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("tables.duplicateView")) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.confirmDeleteView(view)
                            },
                          },
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              staticStyle: { color: "#ff4d4f" },
                            },
                            [_vm._v("delete")]
                          ),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("tables.deleteView")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ])
      }),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "view-item other-tables",
          on: { click: _vm.showOtherTables },
        },
        [
          _c("div", { staticClass: "view-content" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("view_list")]),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tables.otherTables")) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "view-actions" },
            [
              _c(
                "a-popover",
                {
                  attrs: {
                    placement: "rightTop",
                    trigger: "click",
                    overlayClassName: "other-tables-popover",
                  },
                  model: {
                    value: _vm.otherTablesVisible,
                    callback: function ($$v) {
                      _vm.otherTablesVisible = $$v
                    },
                    expression: "otherTablesVisible",
                  },
                },
                [
                  _c("template", { slot: "content" }, [
                    _c("div", { staticClass: "other-tables-menu" }, [
                      _c(
                        "div",
                        { staticClass: "other-tables-header" },
                        [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.$t("tables.otherTables"))),
                          ]),
                          _vm._v(" "),
                          _c("a-input-search", {
                            staticStyle: {
                              width: "100%",
                              "margin-bottom": "10px",
                            },
                            attrs: { placeholder: _vm.$t("message.search") },
                            on: { input: _vm.onTableSearch },
                            model: {
                              value: _vm.tableSearchText,
                              callback: function ($$v) {
                                _vm.tableSearchText = $$v
                              },
                              expression: "tableSearchText",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "other-tables-list" },
                        [
                          _vm._l(_vm.filteredTables, function (table) {
                            return _c(
                              "div",
                              {
                                key: table._id,
                                staticClass: "other-table-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.navigateToTable(table._id)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("table_chart"),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(table.name))]),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.filteredTables.length === 0
                            ? _c("div", { staticClass: "no-tables" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("tables.noTablesFound")) +
                                    "\n                            "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "i",
                    {
                      staticClass: "material-icons",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [_vm._v("keyboard_arrow_right")]
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c("PermissionController", { attrs: { permissions: ["table.update"] } }, [
        _c(
          "div",
          {
            staticClass: "view-item add-new",
            on: { click: _vm.createNewView },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
            _vm._v(
              "\n            " + _vm._s(_vm.$t("tables.newView")) + "\n        "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c("div", { staticClass: "footer-text" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$t("tables.createViewaFiltering")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _vm.showRenameModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("tables.renameView"),
                okText: _vm.$t("message.save"),
                cancelText: _vm.$t("message.cancel"),
              },
              on: { cancel: _vm.closeRenameModal, ok: _vm.handleRename },
            },
            [
              _c(
                "a-form-item",
                { attrs: { label: _vm.$t("tables.enterNewViewName") } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "Görünüm adı girin" },
                    model: {
                      value: _vm.newViewName,
                      callback: function ($$v) {
                        _vm.newViewName = $$v
                      },
                      expression: "newViewName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }